import { NotesIllustration } from '@carboncopyco/illustrations';
import { Button, EmptyView, TextBase } from '@carboncopyco/ui';

type EmptyStateProps = {
  isEditable: boolean;
  onAddNote: () => void;
};

export const EmptyState = ({ isEditable, onAddNote }: EmptyStateProps) => {
  return (
    <EmptyView
      illustration={<NotesIllustration />}
      title="No speaker notes"
      message={
        <div className="flex flex-col items-center">
          <TextBase
            label="Add guidance or script reminders that are visible only to presenters during demos"
            color="text-ds-natural-300"
          />
          {isEditable && (
            <div className="pt-3">
              <Button
                link
                label="Add notes"
                onClick={(event) => {
                  event.stopPropagation();
                  onAddNote();
                }}
              />
            </div>
          )}
        </div>
      }
    />
  );
};
